import { getFirestoreDocumentValue } from '../../utils/firebaseConfig';

import { SendingChannelWarning } from './types';

export const getFirebaseCustomMessage = async () => {
  const customMessageDocument = (
    await getFirestoreDocumentValue('mensagemCanalEnvio')
  ).data() as SendingChannelWarning;
  return {
    sendingChannelMessage: customMessageDocument.mensagem,
  };
};
